import { useMemo } from 'react';

import type { CarouselItem } from '../types';

import type { Bucket } from '@shared-types/uefatv.types';
import { mapEditorialContent } from '@utilities/uefatv';

/**
 * Transforms a Bucket into a CarouselItem for use in UEFA TV carousel components.
 *
 * @param bucket - The source Bucket containing content data
 * @returns An object with transformed carousel data
 */
export const useCarouselItem = (bucket: Bucket) => {
  const carousel: CarouselItem = useMemo(() => {
    return {
      id: bucket?.exid,
      type: bucket?.type,
      title: bucket?.rowTypeData?.title,
      description: bucket?.rowTypeData?.description,
      items: bucket?.contentList.map((c) => mapEditorialContent(c)),
    };
  }, [bucket]);
  return { carouselData: carousel };
};
